import { Link } from "react-router-dom";
import { footerColumns, siteInfo } from "@/mocks/site";
import NewsletterForm from "@/components/feature/NewsletterForm";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 border-t border-background-200 bg-secondary-950 text-background-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-secondary-950">
                <i className="ri-emotion-happy-line text-xl"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">{siteInfo.name}</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300/90">
              {siteInfo.intro}如果你也喜欢在碎片时间里找点乐子，欢迎订阅每周更新提醒。
            </p>
            <div className="mt-6 max-w-lg">
              <NewsletterForm />
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">{column.title}</h3>
              <ul className="mt-4 space-y-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-300/90 transition-colors hover:text-accent-400"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-50/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-300/80">
            © {year} {siteInfo.name} · 轻松吃瓜，快乐加倍
          </p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-background-300/80">
            <a href={`mailto:${siteInfo.email}`} className="transition-colors hover:text-accent-400">
              {siteInfo.email}
            </a>
            <Link to="/faq" className="transition-colors hover:text-accent-400">
              常见问题
            </Link>
            <Link to="/about" className="transition-colors hover:text-accent-400">
              关于我们
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}